import { render, staticRenderFns } from "./ContactUsWrapper.vue?vue&type=template&id=0f997dfe&scoped=true"
import script from "./ContactUsWrapper.vue?vue&type=script&lang=js"
export * from "./ContactUsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f997dfe",
  null
  
)

export default component.exports